<template>
  <div class="markdown-editor-box">
    <link rel="stylesheet" href="/static/js/editor.md/css/editormd.css">
    <div :id="editorId"></div>
  </div>
</template>
<script>
function uuid () {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('')
}

export default {
  model: {
    prop: 'modelValue',
    event: 'onChangeContent'
  },
  props: {
    /**
     * 是否只做展示 真只展示 假则成为编辑器
     */
    show: {
      type: Boolean,
      default: false
    },
    /**
     * 标识 当内容改变时会传递标识过去  一般多个编辑器的时候可用用于标识
     */
    tag: {
      type: String,
      default: uuid()
    },
    /**
     * 标识 当内容改变时会传递标识过去  一般多个编辑器的时候可用用于标识
     */
    editorId: {
      type: String,
      default: uuid()
    },
    /**
     * 内容被改变事件 该事件接受一个参数
     * {
        markdown: editor.getMarkdown(),
        tag: this.tag,
        editorId: this.editorId,
        editor: editor,
        vm: this
      }
     */
    onchange: {
      type: Function
    },
    // 编辑器配置
    config: {
      type: Object
    },
    /**
     * 初始化加载的内容
     */
    modelValue: {
      type: String,
      default: ''
    },
    /**
     * 延迟初始化数据时间，单位毫秒
     */
    delay: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      required: false,
      default: '600px'
    },
  },
  data: function () {
    return {
      editor: null,
      defaultConfig: {
        width: '100%',
        height: this.height,
        path: '/static/js/editor.md/lib/',
        // theme: 'dark',
        // previewTheme: 'dark',
        // editorTheme: 'pastel-on-dark',
        markdown: '',
        codeFold: true,
        // syncScrolling : false,
        saveHTMLToTextarea: true, // 保存 HTML 到 Textarea
        searchReplace: true,
        // watch : false,                // 关闭实时预览

        toolbar  : true,             //关闭工具栏
        // previewCodeHighlight : false, // 关闭预览 HTML 的代码块高亮，默认开启
        emoji: true,
        taskList: true,
        tocm: true, // Using [TOCM]
        tex: true, // 开启科学公式TeX语言支持，默认关闭
        flowChart: true, // 开启流程图支持，默认关闭
        sequenceDiagram: true, // 开启时序/序列图支持，默认关闭,
        // dialogLockScreen : false,   // 设置弹出层对话框不锁屏，全局通用，默认为true
        // dialogShowMask : false,     // 设置弹出层对话框显示透明遮罩层，全局通用，默认为true
        // dialogDraggable : false,    // 设置弹出层对话框不可拖动，全局通用，默认为true
        // dialogMaskOpacity : 0.4,    // 设置透明遮罩层的透明度，全局通用，默认值为0.1
        // dialogMaskBgColor : "#000", // 设置透明遮罩层的背景颜色，全局通用，默认为#fff
        imageUpload: true,
        imageFormats: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'webp'],
        imageUploadURL: this.$baseUrl + '/api/file/update.do',
        // htmlDecode: 'style,script,iframe|on*', // 开启 HTML 标签解析，为了安全性，默认不开启
        htmlDecode: 'style,script,iframe', // 您可以过滤标签解码
        // toc             : false,
        // tocContainer    : "#custom-toc-container", // 自定义 ToC 容器层
        // gfm             : false,
        // tocDropdown     : true,
        // markdownSourceCode : true, // 是否保留 Markdown 源码，即是否删除保存源码的 Textarea 标签
        onload: function () {
          this.watch()
          // console.log('onload', this)
          // this.fullscreen();
          // this.watch().fullscreen();
          // this.setMarkdown("#PHP");
          // this.width("100%");
          // this.height(480);
          // this.resize("100%", 640);
        },
        onchange: function () {
          if (this.onContentChange && typeof this.onContentChange === 'function') {
            this.onContentChange(this)
          }
        }
      }
    }
  },
  methods: {

    getConfig () {
      return { ...this.defaultConfig, ...this.config }
    },
    getEditor () {
      return this.editor
    },
    watch () {
      return this.editor.watch()
    },
    unwatch () {
      return this.editor.unwatch()
    },
    previewing () {
      return this.editor.previewing()
    },
    getHTML () {
      return this.editor.getHTML()
    },
    getMarkdown () {
      return this.editor.getMarkdown()
    },
    setMarkdown (markdown) {
      return this.editor.setMarkdown(markdown)
    },
    onContentChange (editor) {
      let res = {
        markdown: editor.getMarkdown(),
        tag: this.tag,
        editorId: this.editorId,
        editor: editor,
        vm: this
      }
      if (this.onchange) {
        this.onchange(res)
      }
      this.$emit('onChangeContent', res.markdown)
    },

    initEditor (markdown) {
      let config = this.getConfig()
      if (markdown) {
        config.markdown = markdown
      }
      // 下载Emoji表情到本地 如果不需要则屏蔽即可
      // You can custom Emoji's graphics files url path
      window.editormd.emoji = {
        path: '/editormd/plugins/emoji-dialog/emoji/',
        ext: '.png'
      }

      // Twitter Emoji (Twemoji)  graphics files url path
      window.editormd.twemoji = {
        path: 'http://twemoji.maxcdn.com/72x72/',
        ext: '.png'
      }
      // 下载Emoji表情到本地 如果不需要则屏蔽即可

      config.onload = function () {
        setTimeout(() => {
          if (this._vm && this._vm.modelValue) {
            this.setMarkdown(this._vm.modelValue)
          }
        }, this.delay)
        this.watch()
      }
      this.$nextTick(() => {
        this.editor = window.editormd(this.editorId, config)
        this.editor.onContentChange = this.onContentChange
        this.editor._vm = this
      })
    }
  },
  mounted () {
    this.initEditor(this.modelValue)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editorMd/index.vue